import { combineReducers } from 'redux'
import { connect } from 'react-redux'

import passwordRecovery from './auth/passwordRecovery'
import session from './auth/session'
import updateCredentials from './auth/updateCredentials'

import invoiceList from './invoice/invoiceList'
import invoiceDetail from './invoice/invoiceDetail'
import invoiceTotalInterval from './invoice/invoiceTotalInterval'
import invoiceAzure from './invoice/invoicesAzure'

import bouncedReceiptList from './bouncedReceipt/bouncedReceiptList'
import bouncedReceiptDetail from './bouncedReceipt/bouncedReceiptDetail'
import bouncedReceiptTotalInterval from './bouncedReceipt/bouncedReceiptTotalInterval'
import bouncedReceiptAzure from './bouncedReceipt/bouncedReceiptsAzure'

import currentAccountList from './currentAccount/currentAccountList'
import currentAccountDetail from './currentAccount/currentAccountDetail'
import currentAccountTotalInterval from './currentAccount/currentAccountTotalInterval'
import currentAccountSummaryList from './currentAccount/currentAccountSummary'

import orderList from './order/orderList'
import orderDetail from './order/orderDetail'
import orderStatuses from './order/orderStatuses'
import orderTotalInterval from './order/orderTotalInterval'

import remittanceList from './remittance/remittanceList'

import prepaymentList from './prepayment/prepaymentList'
import prepaymentDiscounts from './prepayment/prepaymentDiscounts'
import prepaymentDetail from './prepayment/prepaymentDetail'
import usePrepaymentDetail from './prepayment/usePrepaymentDetail'

import complaintList from './complaint/complaintList'
import complaintUpsert from './complaint/complaintUpsert'
import complaintDetail from './complaint/complaintDetail'
import complaintTypes from './complaint/complaintTypes'
import complaintMessage from './complaint/complaintMessage'
import complaintMessageUpsert from './complaint/complaintMessageUpsert'
import complaintMessageDetail from './complaint/complaintMessageDetail'
import complaintInternalMessage from './complaint/complaintInternalMessage'
import complaintInternalMessageUpsert from './complaint/complaintInternalMessageUpsert'
import complaintInternalMessageDetail from './complaint/complaintInternalMessageDetail'
import updateComplaintCount from './complaint/updateComplaintCount'

import clientList from './client/clientList'
import clientDetail from './client/clientDetail'

import personList from './person/personList'
import personUpsert from './person/personUpsert'
import personDetail from './person/personDetail'

import productList from './product/productList'
import productUpsert from './product/productUpsert'
import productDetail from './product/productDetail'

import productBrandList from './product/productBrandList'
import productBrandUpsert from './product/productBrandUpsert'
import productBrandDetail from './product/productBrandDetail'

import productSectionList from './product/productSectionList'
import productSectionUpsert from './product/productSectionUpsert'
import productSectionDetail from './product/productSectionDetail'

import productGroupList from './product/productGroupList'
import productGroupUpsert from './product/productGroupUpsert'
import productGroupDetail from './product/productGroupDetail'

import productSubgroupList from './product/productSubgroupList'
import productSubgroupUpsert from './product/productSubgroupUpsert'
import productSubgroupDetail from './product/productSubgroupDetail'

import productMeasurementList from './product/productMeasurementList'
import productMeasurementUpsert from './product/productMeasurementUpsert'
import productMeasurementDetail from './product/productMeasurementDetail'

import productMeasurementTypeList from './product/productMeasurementTypeList'
import productMeasurementTypeUpsert from './product/productMeasurementTypeUpsert'
import productMeasurementTypeDetail from './product/productMeasurementTypeDetail'

import preorderData from './preorder/preorderData'
import preorderList from './preorder/preorderList'

import preorderProductList from './preorder/preorderProductList'
import preorderAllProductList from './preorder/preorderAllProductList'
import preorderSurplusProduct from './preorder/preorderSurplusProduct'
import preorderDetailData from './preorder/preorderDetailData'
import preorderDetailList from './preorder/preorderDetailList'

import deliveryLocationList from './deliveryLocation/deliveryLocationList'
import deliveryLocationDetail from './deliveryLocation/deliveryLocationDetail'

import provinceList from './province/provinceList'
import localityList from './locality/localityList'

import deliveryAreaList from './deliveryArea/deliveryAreaList'
import logisticWarningList from './logisticWarning/logisticWarningList'

import carrierList from './carrier/carrierList'
import carrierDetail from './carrier/carrierDetail'

import logList from './log/logList'
import logDetail from './log/logDetail'

import vendorList from './vendor/vendorList'
import vendorDetail from './vendor/vendorDetail'
import linkedVendorsList from './person/linkedVendorsList'

import profile from './profile'

import config from './config'
import alert from './alert'
import notifications from './notifications'

import platformList from './generalDescList'
import generalDescList from './generalDescList'
import countries from './country/countries'
import provinces from './province/provinces'
import countryList from './country/countries'
import countryDetail from './country/countryDetail'
import currentPriceList from './currentPriceList'
import infoCurrentPriceList from './infoCurrentPriceList'
import discountList from './discountList'
import preorderCtrlList from './preorder/preorderCtrlList'

import notificationList from './notification/notificationList'
import massNotificationList from './massNotification/massNotificationList'
import massNotificationDetail from './massNotification/massNotificationDetail'

import goalDetail from './goal/goalDetail'
import goalList from './goal/goalList'
import goalStats from './goal/goalStats'
import incotermsList from './incoterms/incotermsList'
import incotermsDetail from './incoterms/incotermsDetail'



export const reducers = combineReducers({
  passwordRecovery,
  session,
  updateCredentials,

  invoiceList,
  invoiceTotalInterval,
  invoiceAzure,
  invoiceDetail,

  bouncedReceiptList,
  bouncedReceiptTotalInterval,
  bouncedReceiptAzure,
  bouncedReceiptDetail,

  currentAccountList,
  currentAccountDetail,
  currentAccountTotalInterval,
  currentAccountSummaryList,

  orderList,
  orderTotalInterval,
  orderDetail,
  orderStatuses,

  remittanceList, 

  prepaymentList,
  prepaymentDetail,
  prepaymentDiscounts,
  usePrepaymentDetail,

  deliveryLocationList,
  deliveryLocationDetail,
  provinceList,
  localityList,

  deliveryAreaList,
  logisticWarningList,

  carrierList,
  carrierDetail,

  incotermsList,
  incotermsDetail,

  logList,
  logDetail,

  vendorList,
  vendorDetail,

  linkedVendorsList,

  notificationList,
  massNotificationList,
  massNotificationDetail,

  goalList,
  goalDetail,
  goalStats,

  complaintList,
  complaintUpsert,
  complaintDetail, 
  complaintTypes,
  complaintMessage, 
  complaintMessageDetail,
  complaintMessageUpsert,
  complaintInternalMessage, 
  complaintInternalMessageDetail,
  complaintInternalMessageUpsert,
  updateComplaintCount,

  clientList, 
  clientDetail,

  personList,
  personUpsert,
  personDetail,

  productList,
  productUpsert,
  productDetail,

  productBrandList,
  productBrandUpsert,
  productBrandDetail,
  
  productSectionList,
  productSectionUpsert,
  productSectionDetail,

  productGroupList,
  productGroupUpsert,
  productGroupDetail,
  
  productSubgroupList,
  productSubgroupUpsert,
  productSubgroupDetail,
  
  productMeasurementList,
  productMeasurementUpsert,
  productMeasurementDetail,
  
  productMeasurementTypeList,
  productMeasurementTypeUpsert,
  productMeasurementTypeDetail,
  
  preorderProductList,
  preorderAllProductList,
  preorderSurplusProduct,
  preorderDetailData,
  preorderDetailList,
  preorderData,
  preorderList,
  preorderCtrlList,

  generalDescList,
  currentPriceList,
  countries,
  provinces,
  countryList,
  countryDetail,
  infoCurrentPriceList,
  discountList,
  profile,

  config,
  alert,

  notifications,

  platformList
})

export type AppState = ReturnType<typeof reducers>

const mapStateToProps = <T extends keyof AppState>(...keys: T[]): any => (state: AppState) => Object.entries(state)
  .filter(([key,]) => keys.includes(key as T))
  .reduce((result, [key, value]) => Object.assign(result, { [key]: value }), {})

export type AppProp<T extends keyof AppState> = Pick<AppState, T>

export const connectApp = <T extends keyof AppState>(...keys: T[]) =>
  <ComponentProps>(component: React.ComponentType<ComponentProps & AppProp<T>>) =>
    connect<AppProp<T>, {}, ComponentProps, AppState>(mapStateToProps(...keys))(component as any)